// Application settings configuration
// To switch environments, change currentEnvironment to 'development' or 'production'

const AppSettings = {
  // Set environment manually: 'development' | 'production'
  currentEnvironment: 'production',

  // Development URL (localhost)
  developmentUrl: 'https://localhost:7116/api/',

  // Production URL
  productionUrl: 'https://api.monitize-media.com/api/',

  // Get the appropriate base URL based on currentEnvironment
  getBaseUrl: () => {
    if (AppSettings.currentEnvironment === 'production') {
      return AppSettings.productionUrl;
    }
    return AppSettings.developmentUrl;
  },

  // Get current environment
  getEnvironment: () => {
    return AppSettings.currentEnvironment;
  },

  // Check if in production
  isProduction: () => {
    return AppSettings.currentEnvironment === 'production';
  },

  // Check if in development
  isDevelopment: () => {
    return AppSettings.currentEnvironment === 'development';
  }
};

// Export the base URL as default
export const baseUrl = AppSettings.getBaseUrl();

// Export the full settings object
export default AppSettings;
